import { hnaviBaseContentCategories } from '@constants';

import { getAllCategoryNamesAndSlugs2 } from '@api';

export const getHnaviContentCategoriesFromCategories = (
  categories: Awaited<ReturnType<typeof getAllCategoryNamesAndSlugs2>>
): { [code: string]: string } => ({
  ...hnaviBaseContentCategories,
  ...Object.fromEntries(
    categories
      ?.filter((c) => !!c.isHnaviCategory)
      .map((c) => [c.hnaviCategoryCode || c.slug, c.name]) || []
  ),
});
